import Model from '../Model';
import Mithril from 'mithril';
import WikiLabelOptionsSon from './WikiLabelOptionsSon';

export default class WikiLabelOptions extends Model {
  labelId() {
    return Model.attribute<number>('labelId').call(this);
  }
  icon() {
    return Model.attribute<string>('icon').call(this);
  }
  name() {
    return Model.attribute<string>('name').call(this);
  }
  sortCount() {
    return Model.attribute<number>('sortCount').call(this);
  }
  status() {
    return Model.attribute<boolean>('status').call(this);
  }
  subIcon() {
    return Model.attribute<string>('subIcon').call(this);
  }
  wikiLabelOptionsSon() {
    return Model.hasMany<WikiLabelOptionsSon>('wikiLabelOptionsSon').call(this);
  }

}
